<app-network-detector (onOnline)="setOnline()" (onOffline)="setOffline()"></app-network-detector>
<app-error-network *ngIf="isOffline"></app-error-network>

<ng-container *ngIf="theme === 'default'">
  <div class="top-bar"></div>
  <div class="content-wrapper">
    <div class="flex-container" *ngIf="showPayButton">
      <button class="solid-button pay-button" (click)="goToPrice()">
        {{ TXT_PAYMENT_OPTION_PAY }}
      </button>
      <button class="solid-promo-button mt-5" (click)="goToPromoType()" *ngIf="showPromoButton">
        {{ TXT_PAYMENT_OPTION_PROMOTION_BUTTON }}
      </button>
    </div>
    <div class="flex-container" *ngIf="!showPayButton">
      <button class="solid-promo-button-2" (click)="goToPromoType()" *ngIf="showPromoButton">
        {{ TXT_PAYMENT_OPTION_PROMOTION_BUTTON }}
      </button>
      <span *ngIf="!showPromoButton">
        No Available Payment or Promotion Method. Please Contact Staff.
      </span>
    </div>
  </div>

  <a (click)="openPIN(content, null)" class="btn btn-light fixed-exit pin-button">
    <img src="assets/img/new/star-icon.png" alt="pin" class="pin-icon">
  </a>
  <div class="fixed-logo">
    <img src="assets/img/new/sculpture-new.png" alt="" class="logo-icon">
  </div>
  <button class="back-button fixed-back" (click)="goToHome()">
    {{ TXT_GLOBAL_BACK_BUTTON }}
  </button>
</ng-container>

<app-payment-or-promo-portrait *ngIf="theme === 'the_portrait'" [host]="this">
</app-payment-or-promo-portrait>

<ng-template #content let-modal>
  <app-staff-pin-dialog [pinMode]="currentHiddenMenuMode"
    (onSuccessVerify)="handleSuccessVerify($event)"
    (onCloseDialog)="handleCloseDialog($event)">
  </app-staff-pin-dialog>
</ng-template>
<ng-template #introContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Before proceed</h4>
        <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button> -->
    </div>
    <div class="modal-body">
        <h5 class="text-center">We need at least 2 person to proceed!</h5>
        <div class="text-center">
            <div class="intro-video-container">
                <video id="intro-webcam" #webcamVideo autoplay muted playsinline></video>
                <canvas id="intro-overlay" #overlayCanvas></canvas>
            </div>
            <div class="mt-2">
                <h5>Person detected: <span class="headline-font">{{ faceCount }}</span></h5>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="w-100 d-flex justify-content-between align-items-center">
            <div>
                <button type="button" class="btn btn-light btn-lg" (click)="onBack()">BACK</button>
            </div>
            <div>
                <button type="button" class="btn btn-dark btn-lg" (click)="goToStepTwo()"
                    [hidden]="!isPersonCountEnough" [class.blink]="isPersonCountEnough">NEXT</button>
            </div>
        </div>
    </div>
</ng-template>
<app-loading *ngIf="commonService.isLoading"></app-loading>